<h2 mat-dialog-title>Establecer tiempo del presupuesto</h2>
<mat-dialog-content>
  <div class="dialog-row">
    <mat-form-field appearance="outline" class="mode-select">
      <mat-label>Tiempo general</mat-label>
      <mat-select [(ngModel)]="mode" name="mode">
        <mat-option value="autocalc">Autocalc</mat-option>
        <mat-option value="manual">Manual (solo budget del tablero)</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="time-input">
      <mat-label>Tiempo</mat-label>
      <input matInput [(ngModel)]="timeInput" name="timeInput" placeholder="4h 30m" cdkFocusInitial (keyup.enter)="submit()" />
    </mat-form-field>
  </div>

  @if (mode === TimeBudgetModeEnum.Autocalc) {
    <p class="category-label">Distribuir en:</p>
    <div class="checkboxes">
      <mat-checkbox [(ngModel)]="devChecked" name="dev">DEV</mat-checkbox>
      <mat-checkbox [(ngModel)]="uxuiChecked" name="uxui">UX/UI</mat-checkbox>
      <mat-checkbox checked="true" disabled="true" name="rev">REV</mat-checkbox>
    </div>
  }

  @if (mode === TimeBudgetModeEnum.Manual) {
    <p class="category-label">Distribuir en:</p>
    <mat-radio-group [(ngModel)]="selectedCategory" name="selectedCategory" (ngModelChange)="selectedCategory = $event">
      <mat-radio-button value="dev">DEV</mat-radio-button>
      <mat-radio-button value="uxui">UX/UI</mat-radio-button>
      <mat-radio-button value="rev">REV</mat-radio-button>
    </mat-radio-group>
  }

  @if (hasBoard && hasGeneralTimeBudgets && mode === TimeBudgetModeEnum.Autocalc) {
    <div class="general-checkbox">
      <mat-checkbox [(ngModel)]="alsoApplyToGeneral" name="alsoApplyToGeneral">Poner tiempo a nivel general también</mat-checkbox>
    </div>
  } @else if (hasBoard && !hasGeneralTimeBudgets && mode === TimeBudgetModeEnum.Autocalc) {
    <p class="no-board-note">El tiempo se aplicará al tablero y se propagará al presupuesto general de la tarea.</p>
  }

  @if (!hasBoard && mode === TimeBudgetModeEnum.Manual) {
    <p class="no-board-note">En modo manual necesitas abrir la tarea desde un tablero.</p>
  }

  @if (errorMessage) {
    <p class="error-message">{{ errorMessage }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" (click)="submit()" [disabled]="saving">
    {{ saving ? 'Guardando…' : 'Aplicar' }}
  </button>
</mat-dialog-actions>
